import { render } from "./RecommendGroup.vue?vue&type=template&id=42a74450&scoped=true"
import script from "./RecommendGroup.vue?vue&type=script&lang=js"
export * from "./RecommendGroup.vue?vue&type=script&lang=js"

import "./RecommendGroup.vue?vue&type=style&index=0&id=42a74450&lang=less&scoped=true"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a74450"]])

export default __exports__